export interface MonthsFromAmplitude {
  fromAmplitude(recurrenceId: number, beginingMonthIndex?: number): string[];
}

export class CachedMonthsFromAmplitude implements MonthsFromAmplitude {
  private _results = new Map<number, string[]>();
  private _beginingIndex = 1;
  private _formatter = new Intl.DateTimeFormat("es", { month: "short" });
  public fromAmplitude(
    amplitude: number,
    beginingMonthIndex?: number
  ): string[] {
    if (
      beginingMonthIndex == null ||
      this._beginingIndex == beginingMonthIndex
    ) {
      const months = this._results.get(amplitude);
      if (months != null) {
        return months;
      }
    }
    const result = this._calculateMonths(
      amplitude,
      beginingMonthIndex ?? this._beginingIndex
    );

    if (
      beginingMonthIndex == null ||
      this._beginingIndex == beginingMonthIndex
    ) {
      this._results.set(amplitude, result);
    }
    return result;
  }

  private _calculateMonths(
    amplitude: number,
    beginingMonthIndex: number
  ): string[] {
    const months = [];
    let index = beginingMonthIndex + amplitude - 1;
    while (index <= 12) {
      const month = new Date(420, index, 1);
      months.push(this._formatter.format(month));
      index = amplitude + index;
    }
    this._results.set(amplitude, months);
    return months;
  }
}
